// This module provides moment with timezone support.
// moment-timezone is a CJS-only package that can't be imported as ESM in Vite.
// We set up a minimal tz shim first, then load moment-timezone asynchronously.
import moment from 'moment';

// Make moment globally available for moment-timezone's UMD wrapper
(globalThis as unknown as Record<string, unknown>).moment = moment;

// Set up a minimal tz shim that will be replaced when moment-timezone loads
if (!moment.tz) {
  const tz = Object.assign(
    (input?: moment.MomentInput, _zone?: string) => {
      return moment(input);
    },
    {
      guess: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
      zone: () => null,
      setDefault: () => {},
      names: () => [],
      load: () => {},
    },
  );
  (moment as unknown as { tz: typeof tz }).tz = tz;
}

// Import moment-timezone async to let the shim be set up first.
// moment-timezone extends the moment singleton in place, so once loaded
// all subsequent calls to moment.tz will use the real implementation.
import('moment-timezone').catch(() => {
  // Shim continues to work if this fails
});

export default moment;
